import { BaseService, BaseServiceOptions } from '../../api/services/base-service';
import { PagedResponse } from '../../common';
import {
  Category
} from '../interfaces';
import { ListCategoriesRequest, SearchCategoriesRequest } from './categories.service.interfaces';

export class CategoriesService extends BaseService {
  catsApiUrl: string;

  constructor(opts: BaseServiceOptions) {
    super(opts);
    this.catsApiUrl = `${this.apiUrl}/marketplace/v1/categories`;
  }

  list(req: ListCategoriesRequest = {}) {
    return this.get<Category[], ListCategoriesRequest>(`${this.catsApiUrl}/list`, req);
  }

  search(req: SearchCategoriesRequest = {}) {
    return this.get<PagedResponse<Category>, SearchCategoriesRequest>(this.catsApiUrl, req);
  }

  getById(id: string) {
    return this.get<Category>(`${this.catsApiUrl}/${id}`);
  }

  listFromAssets() {
    return this.post<Category[], object>(`${this.catsApiUrl}/load`, {});
  }
}
